// extracted by mini-css-extract-plugin
module.exports = {"avatar":"css_avatar__1DI-u"};